import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../useWeb3";
import { getBalance } from "../../utils/contractHelpers";
import {
  LUCKIFY_CONTRACT_ADDRESS,
  USDT_CONTRACT_ADDRESS,
} from "../../utils/Enviroment";

export const useApprove = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  let contract;
  const bigNumberApproval = "100000000000000000";
  const approvee = useCallback(
    async (accounsend) => {
      contract = await getBalance(USDT_CONTRACT_ADDRESS, web3);
      const feeAmount = web3.utils.toWei(bigNumberApproval, "ether");
      let gasPrice = await web3.eth.getGasPrice();
      gasPrice = parseInt(gasPrice);
      try {
        // const gas = await contract.methods
        //   .approve(LUCKIFY_CONTRACT_ADDRESS, feeAmount)
        //   .estimateGas({ from: accounsend });
        const transaction = await contract.methods
          .approve(LUCKIFY_CONTRACT_ADDRESS, feeAmount)
          .send({ from: accounsend });
        return transaction;
      } catch (error) {
        console.error("Approval error:", error);
        throw error;
      }
    },
    [account, contract, web3]
  );

  return approvee;
};
export default useApprove;
